import React from "react";

import "./view-all.css";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import cylinder from "../../../images/icon/icons/cylinder.svg";
import gas from "../../../images/icon/gas.svg";
import landline from "../../../images/icon/icons/landline.svg";
import gaspipeline from "../../../images/icon/icons/pipedgas.svg";
import municipaltax from "../../../images/icon/icons/municipaltax.svg";
import mobile from "../../../images/icon/icons/mobilerecharge.svg";
import municipalservices from "../../../images/icon/icons/municipalservices.svg";
import water from "../../../images/icon/icons/water.svg";
import insurance from "../../../images/icon/icons/insurance.svg";
import bulb from "../../../images/icon/icons/electricity.svg";
import creditcard from "../../../images/icon/icons/card.svg";
import card from "../../../images/icon/icons/card.svg";
import broadbandpostpaid from "../../../images/icon/icons/broadbandpostpaid.svg";
import Searchinput from "app/components/search-input/Searchinput";

function Viewall() {
  return (
    <>
      <PageWrapper title="View All">
        <section id="pay_bills">
          <div className="pay-bills-container view-all">
            <div className="row align-item-center justify-content-center">
              <div className="col-md-11">
                <Searchinput title="Search Utilities" />
              </div>
              <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                <div className="d-flex align-item-center justify-content-between my-2">
                  <h3 className="mb-0 lead">Recharges</h3>
                  {/* <Link className="view-button">
                              View All
                              <i className="material-icons">
                                keyboard_arrow_right
                              </i>
                            </Link> */}
                </div>

                <div className="box-container grid-5 bg-white mb-4">
                  <div className="item">
                    <img src={water} alt="water" className="py-2" />
                    <p className="font-weight-light text-wrap">Water</p>
                  </div>

                  <div className="item">
                    <img src={gaspipeline} alt="Piped gas" className="py-2" />
                    <p className="font-weight-light text-wrap">piped gas</p>
                  </div>

                  <div className="item">
                    <img src={cylinder} alt="gas" className="py-2" />
                    <p className="font-weight-light text-wrap">
                      book a cylinder
                    </p>
                  </div>

                  <div className="item">
                    <img src={landline} alt="landline" className="py-2" />
                    <p className="font-weight-light text-wrap">Landline</p>
                  </div>
                  <div className="item">
                    <img src={insurance} alt="insurance" className="py-2" />
                    <p className="font-weight-light text-wrap">Insurance</p>
                  </div>

                  {/* <div className="item">
                              <img src={card} alt="card" className="py-2" />
                              <p className="font-weight-light text-wrap">
                                Credit card Bill
                              </p>
                            </div> */}
                </div>
              </div>

              <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                <div className="d-flex align-item-center justify-content-between my-2">
                  <h3 className="mb-0 lead">Fees and Charges</h3>
                  {/* <Link className="view-button">
                              View All
                              <i className="material-icons">
                                keyboard_arrow_right
                              </i>
                            </Link> */}
                </div>

                <div className="box-container grid-5 bg-white mb-4">
                  <div className="item">
                    <img src={insurance} alt="insurance" className="py-2" />
                    <p className="font-weight-light text-wrap">Insurance</p>
                  </div>

                  <div className="item">
                    <img src={card} alt="card" className="py-2" />
                    <p className="font-weight-light text-wrap">
                      Credit card Bill
                    </p>
                  </div>

                  <div className="item bg-white">
                    <img
                      src={broadbandpostpaid}
                      alt="Broadband postpaid"
                      className="py-2"
                    />
                    <p className="font-weight-light text-wrap">
                      Broadband postpaid
                    </p>
                  </div>

                  <div className="item">
                    <img src={bulb} alt="Electricity" className="py-2" />
                    <p className="font-weight-light text-wrap">Electricity</p>
                  </div>

                  <div className="item">
                    <img src={insurance} alt="insurance" className="py-2" />
                    <p className="font-weight-light text-wrap">Insurance</p>
                  </div>

                  <div className="item">
                    <img src={mobile} alt="Mobile" className="py-2" />
                    <p className="font-weight-light text-wrap">Mobile</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                <div className="d-flex align-item-center justify-content-between my-2">
                  <h3 className="mb-0 lead"> Utility </h3>
                  <span className="view-button">
                    View All
                    <i className="material-icons">keyboard_arrow_right</i>
                  </span>
                </div>

                <div className="box-container grid-5 bg-white mb-4">
                  <div className="item">
                    <img src={municipalservices} alt="Metro" className="py-2" />
                    <p className="font-weight-light text-wrap">
                      Municipal services
                    </p>
                  </div>

                  <div className="item">
                    <img src={creditcard} alt="Metro" className="py-2" />
                    <p className="font-weight-light text-wrap">Credit Card</p>
                  </div>

                  <div className="item">
                    <img src={gas} alt="Metro" className="py-2" />
                    <p className="font-weight-light text-wrap">Gas</p>
                  </div>

                  <div className="item bg-white">
                    <img src={water} alt="water" className="py-2" />
                    <p className="font-weight-light text-wrap">Water</p>
                  </div>

                  <div className="item">
                    <img src={bulb} alt="Electricity" className="py-2" />
                    <p className="font-weight-light text-wrap">Electricity</p>
                  </div>

                  <div className="item">
                    <img src={insurance} alt="insurance" className="py-2" />
                    <p className="font-weight-light text-wrap">Insurance</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                <div className="d-flex align-item-center justify-content-between my-2">
                  <h3 className="mb-0 lead">Financial Services and Taxes</h3>
                  <span className="view-button">
                    View All
                    <i className="material-icons">keyboard_arrow_right</i>
                  </span>
                </div>

                <div className="box-container grid-5 bg-white mb-4">
                  <div className="item">
                    <img src={insurance} alt="insurance" className="py-2" />
                    <p className="font-weight-light text-wrap">
                      Credit card Bill
                    </p>
                  </div>

                  <div className="item">
                    <img
                      src={municipalservices}
                      alt="Municipal services"
                      className="py-2"
                    />
                    <p className="font-weight-light text-wrap">
                      Municipal services
                    </p>
                  </div>

                  <div className="item">
                    <img src={municipaltax} alt="doctor" className="py-2" />
                    <p className="font-weight-light text-wrap">Municipal Tax</p>
                  </div>

                  <div className="item">
                    <img src={insurance} alt="insurance" className="py-2" />
                    <p className="font-weight-light text-wrap">
                      Credit card Bill
                    </p>
                  </div>

                  <div className="item">
                    <img
                      src={municipalservices}
                      alt="Municipal services"
                      className="py-2"
                    />
                    <p className="font-weight-light text-wrap">
                      Municipal services
                    </p>
                  </div>
                  <div className="item">
                    <img src={mobile} alt="Mobile" className="py-2" />
                    <p className="font-weight-light text-wrap">Mobile</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </PageWrapper>
    </>
  );
}

export default Viewall;
